import React, { JSX } from 'react';

import { Panel, Panels, spacing, usePublicaTranslation } from '~/src/dash/publicaUI';
import { ContentMetadataTable } from '~/src/dash/views/inventory-rules-v2/ContentMetadata/ContentMetadataTable';
import { TopBar } from '~/src/dash/views/topbar/TopBar';

export const ContentMetadataList = (): JSX.Element => {
  const { t } = usePublicaTranslation();
  return (
    <Panels max vertical relative minWidthMain>
      <Panel largeHorizontalPadding paddingTop={spacing.small} paddingBottom={spacing.extraLarge}>
        <TopBar title={t('InventoryRulesContentMetadata')} enableUINotices />
      </Panel>
      <Panels max vertical relative minWidthMain scroll>
        {/* ADD WHEN FORMS ARE IMPLEMENTED */}
        {/* <Panel largeHorizontalPadding style={{ alignSelf: 'flex-end' }}>
          <ButtonV2
            small
            onClick={() => undefined}
            tKey='PlusAddItem'
            tProps={{ item: t('ContentMetadata') }}
          />
        </Panel> */}
        <Panel>
          <ContentMetadataTable />
        </Panel>
      </Panels>
    </Panels>
  );
};
